<template>
   <div class="container-fluid">
      <loading
         loader="bars"
         :active.sync="isLoading"
         :is-full-page="false"
      ></loading>
      <!-- <loading :active.sync="isLoading"></loading> -->
      <div>
         {{ member.name }}，您好:<br />
         您目前累積的經驗值是:
         {{ this.memberProfile.exp }}
      </div>
      <div>最新20筆訂購明細如下:<br /></div>
      <div>
         <table class="table">
            <thead>
               <th class="align-middle">訂單號(非出貨單號)</th>
               <th class="align-middle">數量</th>
               <th class="align-middle">狀態</th>
            </thead>
            <tbody>
               <tr v-for="item in shoppingList.list" :key="item.suuid">
                  <td>
                     {{ item.mas_no }}
                  </td>
                  <td class="align-middle">
                     {{ item.total_qty }}
                  </td>
                  <td>
                     <div v-if="item.status_flg === 'A'">下單</div>
                     <div v-if="item.status_flg === 'T'">接單</div>
                     <div v-if="item.status_flg === 'C'">取消</div>
                     <div v-if="item.status_flg === 'S'">出貨</div>
                  </td>
               </tr>
            </tbody>
            <tfoot></tfoot>
         </table>
      </div>
      <div>
         假設有任何問題，請諮詢北名公司<br />
         (02)2592-7857
      </div>
      <div
         class="modal fade"
         id="productInfoModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true"
      >

      ABC
      </div>
   </div>
</template>

<script>
export default {
   name: "Success",
   data() {
      return {
         order_no: "",
         cart: {},
         memberProfile: {},
         member: {},
         shoppingList: [],
         isLoading: true,
      };
   },
   methods: {
      redirect2Main() {
         this.$router.push(`/customer/customer_order/`);
      },
      getMemberProfile() {
         this.$ecServiceInstance
            .post("/member/profile", {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
            })
            .then((response) => {

               // console.log('response:',response);
               this.memberProfile = response.data.data;
            })
            .catch((e) => {
               console.error(e);
            });
      },
      getMemberShoppingList() {
         this.isLoading = true;
         this.$ecServiceInstance
            .post(`/member/getShoppingList?page=1&page_size=20`, {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
            })
            .then((response) => {
               this.shoppingList = response.data.data;
            })
            .catch((e) => {
               console.error(e);
            });
         this.isLoading = false;
      },
   },
   created() {
      this.isLoading = true;
      this.member = JSON.parse(localStorage.getItem("member"));
      this.getMemberProfile();
      this.getMemberShoppingList();
      this.isLoading = false;
   },
};
</script>

<style scoped>
html,
body {
   height: 100%;
}

body {
   display: -ms-flexbox;
   display: flex;
   -ms-flex-align: center;
   align-items: center;
   padding-top: 40px;
   padding-bottom: 40px;
   background-color: #f5f5f5;
}

.form-signin {
   width: 100%;
   max-width: 330px;
   padding: 15px;
   margin: auto;
}
.form-signin .checkbox {
   font-weight: 400;
}
.form-signin .form-control {
   position: relative;
   box-sizing: border-box;
   height: auto;
   padding: 10px;
   font-size: 16px;
}
.form-signin .form-control:focus {
   z-index: 2;
}
.form-signin input[type="email"] {
   margin-bottom: -1px;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
   margin-bottom: 10px;
   border-top-left-radius: 0;
   border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/CustomerInfo.vue